<div class="modal">
	<div class="modal-content">
		<div style="display: flex; justify-content: space-between; align-items: center;">
			<span style="font-size: 18px; font-weight: 500;">Add Comment</span>
			<span class="close" (click)="close()">&times;</span>
		</div>
		<div class="editable-comments-section">
			<div class="editable-comments-scroll">
				<ng-container *ngFor="let comment of comments; let i = index; trackBy: trackByIndex">
					<div class="editable-comment-item">
						<textarea
							[(ngModel)]="comment.text"
							name="comment-{{i}}"
							placeholder="Add a comment..."
							rows="3"
						></textarea>
						<button *ngIf="comments.length > 1" (click)="removeComment(i)">
							<mat-icon>close</mat-icon>
						</button>
					</div>
				</ng-container>
			</div>
			<div style="text-align: right;">
				<button (click)="addComment()" class="add-comment-btn">
					+ Add
				</button>
			</div>
		</div>
		<div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 18px;">
			<button (click)="close()" style="padding: 6px 18px; border-radius: 4px; border: 1px solid #e0e0e0; background: #fff; color: #222; font-weight: 500;">Cancel</button>
			<button (click)="submit()" [disabled]="loading || validCommentsCount === 0" style="padding: 6px 18px; border-radius: 4px; border: none; background: #222; color: #fff; font-weight: 500;">Save</button>
		</div>
		<div class="api-comments-section">
			<div *ngIf="apiCommentsLoading" class="api-comments-loading">Loading previous comments...</div>
			<div *ngIf="!apiCommentsLoading && apiComments.length > 0" class="api-comments-list-container">
				<strong>All Comments</strong>
				<ul class="api-comments-list">
				<ng-container *ngFor="let c of apiComments">
					<li class="api-comment-item api-comment-card">
						<div *ngIf="c.category_name" class="api-comment-category">{{ c.category_name }}.</div>
						<div class="api-comment-text"><span style="  font-weight: 600;">Comment:</span> {{ c.comment }}</div>
						<div class="api-comment-meta">
							<div class="meta-inner">
								<span class="meta-by">By: {{ c.updated_by || '-' }}</span>
								<span class="meta-on">On: {{ c.displayTimestamp || (c.updated_at ? c.updated_at : '-') }}</span>
							</div>
						</div>
					</li>
				</ng-container>
				</ul>
			</div>
			<div *ngIf="!apiCommentsLoading && apiComments.length === 0" class="api-comments-empty">No previous comments found.</div>
		</div>
	</div>
</div>
